"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'email.payment.success.subject': '付款成功 - 订阅已确认',
    'email.payment.success.title': '付款处理成功！',
    'email.payment.success.text': '感谢您的付款。您的订阅已确认并已激活。',
    'email.payment.success.confirmation': '您将很快收到此付款的收据。',
    'email.payment.success.footer': '如有任何问题，请联系我们的支持团队。',
    'email.payment.failed.subject': '付款失败 - 需要操作',
    'email.payment.failed.title': '付款处理失败',
    'email.payment.failed.text': '我们无法处理您的订阅付款。请更新您的付款方式以继续使用我们的服务。',
    'email.payment.failed.retry_text': '为避免服务中断，请尽快重试付款。',
    'email.payment.failed.retry_button': '重试付款',
    'email.payment.failed.support_button': '联系支持',
    'email.payment.failed.footer': '如果您继续遇到问题，请联系我们的支持团队寻求帮助。',
    'email.payment.plan': '订阅计划',
    'email.payment.amount': '金额',
    'email.payment.next_billing': '下次计费日期',
    'email.payment.failure_reason': '失败原因',
    'email.payment.dashboard_button': '查看控制台',
    'email.payment.download_invoice': '下载发票',
};
